import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { UserAuthDto } from '../../dtos/user-auth.dto';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  get<T>(endpoint: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}${endpoint}`, {
      headers: this.setAuthHeader({})
    });
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}${endpoint}`, body, {
      headers: this.setAuthHeader({})
    });
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}${endpoint}`, body, {
      headers: this.setAuthHeader({})
    });
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}${endpoint}`, {
      headers: this.setAuthHeader({})
    });
  }

  public getAuthToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      const userJson = localStorage?.getItem('user');
      if (userJson || userJson?.length == 0) {
        const user = JSON.parse(userJson) as UserAuthDto;
        return user.tokenType + ' ' + user.token;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  private setAuthHeader(headers: any): any {
    const token = this.getAuthToken();
    if (token) {
      headers['Authorization'] = token;
    }
    return headers;
  }
}